import { lazy } from 'react';
import { Routes } from 'constants/routes';
import Terms from 'components/terms/Terms';

const ContactPageLazy = lazy(() => import('../../pages/contact/Contact'));
const HomePageLazy = lazy(() => import('../../pages/home/Home'));
const AboutPageLazy = lazy(() => import('../../pages/about-us/AboutUs'));
const BlogPageLazy = lazy(() => import('../../pages/blogs/Blogs'));
const ImpactPageLazy = lazy(() => import('../../pages/impact/impact'));
const IndividualTakeActionLazy = lazy(
  () => import('../../pages/take-actions/individual-take-action/IndividualTakeAction'),
);

const CommunityTakeActionLazy = lazy(
  () => import('../../pages/take-actions/community-take-action/CommunityTakeAction'),
);
const CompanyTakeActionLazy = lazy(() => import('../../pages/take-actions/company-take-action/CompanyTakeAction'));
// const VideosPageLazy = lazy(() => import('../../pages/videos/Videos'));
const BlogDetailsLazy = lazy(() => import('../../pages/blog-details/BlogDetails'));
const TermsLazy = lazy(() => import('../../pages/terms/TermsandConditions'));
const ProjectDetailsLazy = lazy(
  () => import('../../components/home-sections/trending-projects-section/ProjectDetails'),
);

export const MainRoutes = [
  {
    path: Routes.contact,
    element: <ContactPageLazy />,
  },

  {
    path: Routes.home,
    element: <HomePageLazy />,
  },

  {
    path: Routes.blog,
    element: <BlogPageLazy />,
  },

  {
    path: Routes.about,
    element: <AboutPageLazy />,
  },
  {
    path: Routes.impact,
    element: <ImpactPageLazy />,
  },

  // {
  //   path: Routes.videos,
  //   element: <VideosPageLazy />,
  // },
  {
    path: Routes.IndividualTakeAction,
    element: <IndividualTakeActionLazy />,
  },
  {
    path: Routes.CommunityTakeAction,
    element: <CommunityTakeActionLazy />,
  },
  {
    path: Routes.CompanyTakeAction,
    element: <CompanyTakeActionLazy />,
  },
  {
    path: Routes.BlogDetails,
    element: <BlogDetailsLazy />,
  },
  {
    path: Routes.Terms,
    element: <TermsLazy />,
  },
  {
    path: Routes.ProjectDetails,
    element: <ProjectDetailsLazy />,
  },
];
